import { useEffect, useState } from 'react';
import { Input } from 'antd';
import AnimationContainer from '../animation-container';
import { streamReturnContent } from '@/utils/qa';
import { postComment } from '@/apis';
import './index.scss';

const { TextArea } = Input;

interface IProps {
    status?: 0 | 1; // 未评价， 已评价
    value?: number; // 选择值
    lucaAskChatId?: string; // luca答疑过来的必传
    askId?: number; // 非luca答的 必传
    handleSubmitComment?: () => void;
    onScrollToBottom?: () => void; // 滚动到底部
}

const QuestionComment = (props: IProps) => {
    const [status, setStatus] = useState(0); // 是否评价
    const [commentValue, setCommentValue] = useState(0); // 选择评价值
    const [inputValue, setInputValue] = useState(''); // 评价值
    const [openDialog, setDialog] = useState(false); // 是否打开弹窗
    const [streamTips, setStreamTips] = useState(() =>
        props.status === 1 ? '很高兴收到你的反馈，如果你还有其他问题，随时向我提问！' : ''
    );
    const [endTips, setEndTips] = useState(() => (props.status === 1 ? '本次答疑服务已结束，感谢你的咨询' : ''));

    // 满意度选择列表
    const notChooseList: string[] = [
        'https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/26/77434_20240926110006.png',
        'https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/26/f1ad4_20240926105852.png',
        'https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/26/385c2_20240926105750.png',
        'https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/26/22dc1_20240926105700.png',
        'https://simg01.gaodunwangxiao.com/uploadfiles/files/202409/26/b3762_20240926105544.png',
    ];

    // 满意列表
    const satisfiedList: string[] = [
        'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202403/11/323a6_20240311143853.png',
        'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202403/11/f6ea4_20240311143954.png',
        'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202403/11/9dc44_20240311144019.png',
        'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202403/11/a7d1f_20240311144520.png',
        'http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202403/11/dd873_20240311144545.png',
    ];

    const commentDesc = ['非常不满意', '不满意', '不太满意', '满意', '非常满意'];

    const handleChoose = (i: number) => {
        setCommentValue(i);
        setDialog(true);
    };

    const handleSubmit = async () => {
        setDialog(false);
        const { status } = await postComment({
            starLevel: commentValue,
            content: inputValue,
            lucaAskChatId: props.lucaAskChatId,
            askId: props.askId,
        });
        if (status !== 0) return;
        setStatus(1);
        props.handleSubmitComment?.();
    };

    const handleAnimationendOfEmoticon = async () => {
        await streamReturnContent('很高兴收到你的反馈，如果你还有其他问题，随时向我提问！', content => {
            setStreamTips(content);
        });
        setEndTips('本次答疑服务已结束，感谢你的咨询');
    };

    useEffect(() => {
        if (props.value) {
            setCommentValue(props.value);
        }
        if (props.status) {
            setStatus(props.status);
        }
    }, [props.value, props.status]);

    useEffect(() => {
        if (streamTips || endTips) {
            props.onScrollToBottom?.();
        }
    }, [streamTips, endTips]);

    if (status !== 1) {
        return (
            <div className="satisfied-box">
                <div className="comment-tip" style={{ color: '#FF6813' }}>
                    问题的解答满意吗
                </div>

                <div className="expression-list">
                    {notChooseList.map((item, index) => (
                        <div key={item} className="expression-container">
                            <img className="expression-icon" src={item} onClick={() => handleChoose(index + 1)} />
                        </div>
                    ))}
                </div>

                {openDialog && (
                    <div className="comment-modal">
                        <AnimationContainer className="modal-content" type="from_small_to_big">
                            <div>发表评价</div>
                            <div>提交评价后，该提问将不可再追问哦～</div>
                            <div className="handle-comment">
                                <AnimationContainer type="jitter_up_and_down">
                                    <img src={satisfiedList[commentValue - 1]} />
                                </AnimationContainer>
                                {commentDesc[commentValue - 1]}
                            </div>

                            <TextArea
                                style={{ boxShadow: 'none', padding: '10px', borderRadius: '12px' }}
                                placeholder="描述具体原因，您的反馈会帮助我们做得更好～"
                                autoSize={{ minRows: 6 }}
                                maxLength={500}
                                value={inputValue}
                                onChange={e => setInputValue(e.target.value)}
                            />

                            <div className="btn-box">
                                <div
                                    onClick={() => {
                                        setDialog(false);
                                        setInputValue('');
                                    }}
                                >
                                    取消
                                </div>
                                <div onClick={handleSubmit}>提交</div>
                            </div>
                        </AnimationContainer>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="satisfied-box">
            <div className="comment-tip" style={{ color: '#A5A5A5' }}>
                问题的解答满意吗
            </div>
            <div className="handle-comment">
                <AnimationContainer type="jitter_up_and_down" animationend={handleAnimationendOfEmoticon}>
                    <img src={satisfiedList[commentValue - 1]} />
                </AnimationContainer>
                <span>{commentDesc[commentValue - 1]}</span>
            </div>
            {streamTips && <div className="comment-tip-card">{streamTips}</div>}
            <AnimationContainer type={endTips ? 'fade_in' : undefined}>
                <div className="comment-tip-text">{endTips}</div>
            </AnimationContainer>
        </div>
    );
};

export default QuestionComment;
